import React from "react";
import GenericAdminCRUD from "../components/GenericAdminCRUD";

const KINDS = [
  { value: "payment", label: "Pagamento (recebido)" },
  { value: "due", label: "A pagar (parcela do contrato)" },
  { value: "invested", label: "Investimento (mídia/tráfego/produção)" },
  { value: "leads", label: "Leads (quantidade)" },
  { value: "units_sold", label: "Unidades Vendidas (quantidade)" },
  { value: "cpl", label: "CPL (R$)" },
];
const SUBS = [
  { value: "", label: "—" },
  { value: "midia", label: "Mídia" },
  { value: "trafego_pago", label: "Tráfego Pago" },
  { value: "producao_grafica", label: "Produção Gráfica" },
  { value: "producao_av", label: "Produção AV (Filme/Foto)" },
  { value: "producao_eventos", label: "Eventos" },
  { value: "producao_acoes", label: "Ações" },
];

export default function ClientFinancialsEditor() {
  return (
    <GenericAdminCRUD
      title="Financeiro & Métricas por Campanha"
      subtitle="Registre pagamentos, valores devidos, investimentos por canal, leads, CPL e unidades vendidas."
      path="client-financials"
      fields={[
        { key: "client_id", label: "Cliente *", type: "clientSelect" },
        { key: "product_id", label: "Produto", type: "productSelect" },
        { key: "campaign_id", label: "Campanha", type: "campaignSelect" },
        { key: "kind", label: "Tipo *", type: "select", options: KINDS },
        { key: "subcategory", label: "Subcategoria (para 'invested')", type: "select", options: SUBS },
        { key: "department", label: "Departamento", type: "select", options: ["Atendimento", "Planejamento/Estratégia", "Criação", "Mídia", "Tráfego Pago", "Produção"] },
        { key: "amount", label: "Valor / Quantidade *", type: "number" },
        { key: "date", label: "Data", type: "date" },
        { key: "note", label: "Observação", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "date", label: "Data" },
        { key: "kind", label: "Tipo" },
        { key: "subcategory", label: "Subcategoria" },
        { key: "amount", label: "Valor" },
        { key: "campaign_id", label: "Campanha", render: (it, { campaigns }) => campaigns.find((c) => c.id === it.campaign_id)?.name || "—" },
      ]}
    />
  );
}
